import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PeopleIcon from '@mui/icons-material/People';

const ProfileFriendsTab = ({ isOwnProfile, userId }) => {
  // TODO: Implement friends list functionality
  // - For own profile: show all friends
  // - For other profiles: show mutual friends

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '20rem',
        backgroundColor: '#1C1E20',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: '4px',
        padding: '3rem',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(232, 163, 61, 0.1)',
          borderRadius: '4px',
          border: '1px solid rgba(232, 163, 61, 0.3)',
          padding: '1rem',
          marginBottom: '1rem',
        }}
      >
        <PeopleIcon style={{ fontSize: '3rem', color: '#E8A33D' }} />
      </Box>
      <Typography
        sx={{
          fontSize: '1.1rem',
          fontWeight: 700,
          color: '#ffffff',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          marginBottom: '0.5rem',
          textAlign: 'center',
        }}
      >
        {isOwnProfile ? 'Your Friends' : 'Mutual Friends'}
      </Typography>
      <Typography
        sx={{
          fontSize: '0.9rem',
          color: '#999999',
          textAlign: 'center',
        }}
      >
        No friends to display yet.
      </Typography>
    </Box>
  );
};

ProfileFriendsTab.propTypes = {
  isOwnProfile: PropTypes.bool.isRequired,
  userId: PropTypes.string,
};

export default ProfileFriendsTab;
